import React from 'react';
import { useTimer } from '../lib/TimerContext';
import { Play, Square, X, Clock, FolderKanban } from 'lucide-react';
import { Button } from './ui/button';

const FloatingTimerBar = () => {
  const { isRunning, timerData, formatElapsedTime, stopTimer, cancelTimer, loading } = useTimer();

  // Don't show if not running or still loading
  if (loading || !isRunning) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 bg-black text-white px-6 py-3 shadow-[4px_4px_0px_0px_rgba(246,230,0,1)] border-2 border-[#F4E600] flex items-center gap-4"
      data-testid="floating-timer-bar"
    >
      {/* Timer display */}
      <div className="flex items-center gap-2">
        <Clock size={18} className="text-[#F4E600] animate-pulse" />
        <span className="font-oswald text-2xl font-bold tracking-wider tabular-nums" data-testid="timer-display">
          {formatElapsedTime()}
        </span>
      </div>
      
      {/* Divider */}
      <div className="w-px h-8 bg-gray-600" />
      
      {/* Project info */}
      <div className="flex flex-col min-w-[150px] max-w-[250px]">
        <div className="flex items-center gap-1 text-[#F4E600]">
          <FolderKanban size={14} />
          <span className="font-oswald text-sm uppercase truncate">
            {timerData.project_name || 'Projekt'}
          </span>
        </div>
        {timerData.task_name && (
          <span className="text-xs text-gray-400 font-serif truncate">
            {timerData.task_name}
          </span>
        )}
        {timerData.description && (
          <span className="text-xs text-gray-500 font-serif truncate">
            {timerData.description}
          </span>
        )}
      </div>
      
      {/* Divider */}
      <div className="w-px h-8 bg-gray-600" />
      
      {/* Controls */}
      <div className="flex items-center gap-2">
        <Button
          onClick={stopTimer}
          className="bg-[#F4E600] text-black hover:bg-yellow-400 rounded-none h-8 px-3 font-oswald uppercase text-sm"
          data-testid="stop-timer-btn"
        >
          <Square size={14} className="mr-1" />
          Uložit
        </Button>
        <Button
          onClick={cancelTimer}
          variant="ghost"
          className="text-gray-400 hover:text-red-500 hover:bg-transparent rounded-none h-8 px-2"
          data-testid="cancel-timer-btn"
          title="Zrušit bez uložení"
        >
          <X size={18} />
        </Button>
      </div>
    </div>
  );
};

export default FloatingTimerBar;
